import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('teamDetailsTabs');

    return {
        ACTIVE: t('active')
    };
};

export default useTranslation;
